module.exports = __webpack_public_path__ + "img/coin.53a28813.png";